import { ArchiveReason } from 'types/domain';

const ARCHIVE_REASONS: Record<ArchiveReason, { value: ArchiveReason; label: string }> = {
    contacts_request: { value: 'contacts_request', label: "Contact's request" },
    deceased: { value: 'deceased', label: 'Deceased' },
    duplicate: { value: 'duplicate', label: 'Duplicate' },
    inactivity: { value: 'inactivity', label: 'Inactivity' },
    legal: { value: 'legal', label: 'Legal' },
    temporary: { value: 'temporary', label: 'Temporary' },
    other: { value: 'other', label: 'Other' },
};

export { ARCHIVE_REASONS };
